import { RemoveQsrMasterModalProps } from './QsrModal.types';
import Modal from '../../../components/Modal/Modal';
import Input from '../../../components/Input/Input';
import { Disclaimer, ReadOnlyInputs } from '../QsrDept.styles';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { StyledButtons } from '../../RawProdGINs/RawProdGins.style';
import Button from '../../../components/Button/Button';
import { Variant } from '../../../components/Button/Button.types';
import React from 'react';

export const RemoveQsrDeptMasterModal = ({ open, onClose, onCancel, onConfirm, formErrors, classOptions, selectedQsrDeptMaster }: RemoveQsrMasterModalProps): JSX.Element => {
  return (
    <Modal id="removeQsrDeptMasterModal" open={open} onClose={onClose}
           title="Remove Qsr Dept Master">
      <div>
        <ReadOnlyInputs>
          <Input
            label="Department description"
            disabled
            id="departmentDescription"
            value={`${selectedQsrDeptMaster?.id} ~ ${selectedQsrDeptMaster?.description}`}
          />
          <Dropdown
            label="Class"
            id="removeQsrMasterClassNo"
            options={classOptions}
            value={selectedQsrDeptMaster?.classNo?.toString() ?? undefined}
            errorText={formErrors?.classDescription}
            disabled={true}
          />
        </ReadOnlyInputs>
        <StyledButtons>
          <Button label="Cancel" testId="closeModalButton" onClick={onCancel}
                  variant={Variant.Secondary} />
          <Button label="Delete" testId="removeQsrMasterRecord" onClick={onConfirm}
                  variant={Variant.Primary} />
        </StyledButtons>
        <Disclaimer>
          * By deleting this record all associated Xrefs will be deleted as well.
        </Disclaimer>
      </div>
    </Modal>
  );
};

export default RemoveQsrDeptMasterModal;
